import {
  Box,
  Flex,
  Modal as ChakrauiModal,
  ModalBody,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import dynamic from 'next/dynamic';
import type { FC } from 'react';
import { When } from 'react-if';
import { Close } from '../Icon';
import ModalHeader from './ModalHeader';
import type { ModalProps } from './types';

const IconButton = dynamic(() => import('@/components/Button/IconButton'), {
  ssr: false,
});

const Modal: FC<ModalProps> = ({
  noHeader = false,
  noMaxHeight = false,
  disabled = false,
  noBodyGap = false,
  onClose,
  isOpen,
  ...props
}) => {
  const {
    children,
    title,
    handleBack,
    action,
    maxWidth,
    hasCloseButton = true,
    'data-testid': testId,
  } = props;
  const maxW = maxWidth || { sm: 'calc(100% - 48px)', md: '480px' };
  return (
    <ChakrauiModal
      isCentered={true}
      onClose={onClose}
      isOpen={isOpen}
      scrollBehavior="outside"
      motionPreset="slideInBottom"
      closeOnOverlayClick={!disabled}
      closeOnEsc={!disabled}
      {...props}
    >
      <ModalOverlay height="100vh" />
      <ModalContent
        ml={{ base: '24px', md: '0px' }}
        mr={{ base: '24px', md: '0px' }}
        boxShadow="unset"
        background="unset"
        maxW={maxW}
        data-testid={testId}
      >
        <When condition={hasCloseButton}>
          <Flex justify="flex-end" mb="12px">
            <IconButton
              data-testid="modal_buttonClose"
              onClick={onClose}
              aria-label="Close"
              icon={<Close />}
              bg="white"
              disabled={disabled}
            />
          </Flex>
        </When>
        <Box borderRadius="8px" bg="white">
          <When condition={!noHeader}>
            <ModalHeader
              showed={!!title || !!handleBack || !!action}
              {...props}
            />
          </When>
          <ModalBody padding={0} overflow="hidden">
            <Box
              overflowY="auto"
              maxHeight={noMaxHeight ? 'unset' : { sm: '65vh', md: '350px' }}
              paddingTop={!noBodyGap ? '24px' : 0}
              paddingBottom={!noBodyGap ? '24px' : 0}
              paddingX={!noBodyGap ? '24px' : 0}
            >
              {children}
            </Box>
          </ModalBody>
        </Box>
      </ModalContent>
    </ChakrauiModal>
  );
};

export default Modal;
